const initialState = [];

export function ComponentPropReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_COMPONENT_PROP": {
      return [
        ...state,
        {
          Table_Key: action.payload.Table_Key,
          props: action.payload.props,
        },
      ];
    }
    // case "SET_COMPONENT_PROP_FOR_F2": {
    //   return [
    //     ...state,
    //     {
    //       ComponentPropForF2: action.payload,
    //       F2Modaltoggle: true,
    //     },
    //   ];
    // }
    case "CLEAR_ALL_COMPONENTS":
      return [];
    case "CLEAR_COMPONENT_PROP": {
      return state.slice(0, -1); // Removes the last object from the array
    }
    default:
      return state;
  }
}
